import gsap from "gsap";
import {$dom} from '../../../helpers/dom';
import {$style} from '../../../helpers/style';
import variables from '../../../variables';
import {ScrollTrigger} from 'gsap/ScrollTrigger'

const {
	exist,
	getAll,
	get
} = $dom;

const {offset} = $style;

export default function createCapabilitiesAnimation(
	sectionSelector = '.js-home-capabilities-section',
	listSelector = '.js-home-capabilities-list',
	itemSelector = '.js-home-capabilities-item',
	logoSelector = '.js-home-capabilities-logo',
	pinSelector = '#js-home-capabilities-pin'
) {

	if (exist([
		sectionSelector,
		listSelector,
		itemSelector,
		logoSelector,
		pinSelector
	])) {
		const
			section = get(sectionSelector),
			list = get(listSelector, section),
			items = getAll(itemSelector, section),
			logos = getAll(logoSelector, section),
			pin = get(pinSelector),
			initOffsetLeft = offset(list).left,
			commonWidth = items.reduce((ac, item) => ac+item.offsetWidth + gsap.getProperty(item, 'margin-left' || 0), 0),
			shiftX = (commonWidth + initOffsetLeft) - variables.windowWidth + initOffsetLeft,
			yOffsetBetweenTrigger = offset(section).top - offset(pin).top
		;

		gsap.set(listSelector, {clearProps: 'width,overflow'});

		ScrollTrigger.matchMedia({
			"(min-width: 992px)": () => {
				gsap.timeline({
					scrollTrigger: {
						trigger: pin,
						start: `+=${yOffsetBetweenTrigger} center-=${gsap.getProperty(section, 'height') / 1.75}`,
						end: '+=150%',
						scrub: true,
						pin: true
					}
				})
					.to(list, {
						x: -shiftX
					}, 0)
					.from(logos, {
						rotate: 360,
						stagger: .02,
						transformOrigin: 'center center'
					}, 0)
				;
			},
			"(max-width: 991px)": () => {


				const
					listCurrentWidth = gsap.getProperty(listSelector, 'width'),
					listOffsetRight = variables.windowWidth - (listCurrentWidth + $style.offset(listSelector).left)
				;

				gsap.set(listSelector, {
					width: listCurrentWidth + listOffsetRight,
					overflow: 'auto'
				})
			}
		});
	}
}
